import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CookiesService } from './cookie.service';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { CookieSettingsModalComponent } from './cookie-settings/cookie-settings-modal.component';
import { GpuModalModule } from '@geneplanet/ngx-ui/src/lib/modal';
import { GpuSwitchModule } from '@geneplanet/ngx-ui/src/lib/switch';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    TranslateModule,
    GpuModalModule,
    GpuSwitchModule,
  ],
  declarations: [CookieConsentComponent, CookieSettingsModalComponent],
  providers: [CookiesService],
  exports: [CookieConsentComponent],
})
class CookiesModule {}

export { CookiesModule, CookieConsentComponent, CookieSettingsModalComponent };
